import path from "node:path";
import { pathToFileURL } from "node:url";
import { RuntimeConfig } from "./types";

export type UserConfig = {
  generators?: Record<string, () => unknown>;
  delay?: number | { min: number; max: number };
  errorRate?: number;
};

export async function loadConfig(cwd: string = process.cwd()): Promise<UserConfig | null> {
  const candidates = ["api-mock-smart.config.js", "api-mock-smart.config.cjs"];

  for (const file of candidates) {
    const fullPath = path.join(cwd, file);
    try {
      const url = pathToFileURL(fullPath).href;
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const mod = await import(url);
      const cfg = (mod.default ?? mod) as UserConfig;
      if (cfg && typeof cfg === "object") {
        return cfg;
      }
    } catch {
      // Ignore missing/invalid config and try next
    }
  }

  return null;
}

export function normalizeConfig(user?: UserConfig | null): RuntimeConfig {
  if (!user) return {};

  const runtime: RuntimeConfig = {
    generators: user.generators,
    errorRate: user.errorRate
  };

  if (typeof user.delay === "number") {
    runtime.delayRange = { min: user.delay, max: user.delay };
  } else if (user.delay && typeof user.delay === "object") {
    runtime.delayRange = {
      min: user.delay.min,
      max: user.delay.max
    };
  }

  return runtime;
}


